import React, { Component } from 'react'

export class Home extends Component {
  render () {
    return <div>
      <h3 className='header'>NEX Outlets</h3>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/pages/home.js